<template>
	<sf-data-table
		ref="grpTable"
		:excel="isButton_(scrId, 'EX')"
		paging
		index
		:columns="cols"
		:rows="rows"
		:stripe="false"
		:selection="false"
		:customExcel="excelFunc"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		@changedPage="changedPage"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcRoList/store/helpers';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
import utils from '@/utils';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			cuRslt: '',
			bfRslt: ''
		};
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.grdList;
		},
		cols() {
			return this.dayCols_;
		}
	},
	methods: {
		...serviceMethods,
		...utils,
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}

			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			/*날짜 포멧변환*/
			var strtMm01, endMm01, strtMm02, endMm02;

			if (this.searchParams.strtMm01) {
				strtMm01 = this.$moment(this.searchParams.strtMm01).format('YYYYMMDD');
			} else {
				strtMm01 = '';
			}
			if (this.searchParams.endMm01) {
				endMm01 = this.$moment(this.searchParams.endMm01).format('YYYYMMDD');
			} else {
				endMm01 = '';
			}
			if (this.searchParams.strtMm02) {
				strtMm02 = this.$moment(this.searchParams.strtMm02).format('YYYYMMDD');
			} else {
				strtMm02 = '';
			}
			if (this.searchParams.endMm02) {
				endMm02 = this.$moment(this.searchParams.endMm02).format('YYYYMMDD');
			} else {
				endMm02 = '';
			}

			queryStr = objectToQuerystring({
				htwoCorp: this.searchParams.htwoCorp, //생산법인
				plntCd: this.searchParams.plntCd, //생산공장
				carScn: this.searchParams.carScn, //차량구분
				srchMm01: this.searchParams.srchMm01, //판매월
				pacScn: this.searchParams.pacScn, //승상구분
				srchMm02: this.searchParams.srchMm02, //조건월
				partNo: this.searchParams.partNo, //품번
				roNo: this.searchParams.roNo, //RO No
				prtlSbc: this.searchParams.prtlSbc, //특이사항검색
				strtTotCst: this.searchParams.strtTotCst, //비용(from)
				endTotCst: this.searchParams.endTotCst, //비용(to)
				saleNat: this.searchParams.saleNat, //판매국가
				saleRegn: this.searchParams.saleRegn, //판매지역
				flclSpc: this.searchParams.flclSpc, //연료전지사양
				cType: this.searchParams.cType, //클레임타입
				phmnCd: this.searchParams.phmnCd, //현상코드
				carTypeNm: this.searchParams.carTypeNm, //차종유형
				opCd: this.searchParams.opCd, //작업코드
				cmpnNo: this.searchParams.cmpnNo, //캠페인번호
				prcStepGb: this.searchParams.prcStepGb, //처리단계
				prcRsltCd: this.searchParams.prcRsltCd, //처리결과
				partType: this.searchParams.partType, //부품유형
				idxScn: this.searchParams.idxScn, //지수구분
				ceqType: this.searchParams.ceqType, //정비유형
				useTerm: this.searchParams.useTerm, //사용기간
				check: this.searchParams.check, //누적
				m3IdxScn: this.searchParams.m3IdxScn,

				strtMm01: strtMm01, //strtMm01
				endMm01: endMm01, //endMm01
				strtMm02: strtMm02, //strtMm02
				endMm02: endMm02 //endMm02
			});

			const url = `${BASE_URL}/mqy/clma/pcClamRo/v1/pcClamRoList/excel` + queryStr;

			const params = { url, columns: this.excelCols_ };

			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		}
	}
};
</script>

<style></style>
